
import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_CHECK, AUTH_ERROR } from 'admin-on-rest';

export default (type, params) => {
    
    if (type === AUTH_LOGIN) {
  const {  password } = params;
  const email=params.username;
    const request = new Request('https://api-dev.slika.org.il/api/login', {
            method: 'POST',
            body: JSON.stringify({ email, password }),
            headers: new Headers({ 'Content-Type': 'application/json' }),
        })
          return fetch(request)
            .then(response => {
                //debugger;
                if (response.status < 200 || response.status >= 300) {
                    throw new Error(response.statusText);
                }
                
                return response.json();
            })
            .then(({ token,name }) => {
if (name=='Admin')
{
                localStorage.setItem('token', token);
                localStorage.setItem('username', email);
                localStorage.setItem('name', name);
                
                return Promise.resolve();
}
else

{
      return Promise.reject();
}
            }
            
            );
            
    }
    
 if (type === AUTH_ERROR) {
        const { status } = params;
        if (status === 401 || status === 403) {
            localStorage.removeItem('token');
            return Promise.reject();
        }
        return Promise.resolve();
    }


    if (type === AUTH_LOGOUT) {
        localStorage.removeItem('username');
        localStorage.removeItem('token');
        localStorage.removeItem('name');
        return Promise.resolve();
    }
    if (type === AUTH_CHECK) {
        
        return localStorage.getItem('token') ? Promise.resolve() : Promise.reject();
    }
    
    return Promise.reject('Unkown method');
};



// WEBPACK FOOTER //
// ./src/authClient.js